import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { setSeoMetadata } from '../lib/seo';
import { getPage } from '../tools/transfer/api';
import PageBody from '../tools/transfer/PageBody';
import TransferSiteFooter from '../tools/transfer/TransferSiteFooter';
import TransferSiteHeader from '../tools/transfer/TransferSiteHeader';
import { useTransferTheme } from '../tools/transfer/theme';

/** /p/:slug - an individual page of the Transfer Site template (About, Pricing, FAQ, Support, ...). */
const TransferContentPage = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [missing, setMissing] = useState(false);
  const [dark, toggleTheme] = useTransferTheme();

  useEffect(() => {
    setPage(null);
    setMissing(false);
    getPage(slug).then(setPage).catch(() => setMissing(true));
  }, [slug]);

  useEffect(() => {
    if (page) {
      setSeoMetadata({
        title: page.title,
        description: page.description || page.title,
        canonicalPath: `/p/${slug}`,
        jsonLd: {
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: page.title,
          description: page.description || page.title,
          dateModified: page.updated_at,
        },
      });
    } else if (missing) {
      setSeoMetadata({ title: 'Page not found', noIndex: true });
    }
  }, [page, missing, slug]);

  return (
    <div className={`min-h-screen flex flex-col ${dark ? 'bg-slate-950 text-white' : 'bg-white text-slate-900'}`}>
      <TransferSiteHeader dark={dark} onToggleTheme={toggleTheme} />
      <main className="flex-1 pt-10 pb-16">
        <article className="max-w-3xl mx-auto px-4">
          {page && (
            <>
              <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight mb-8" data-testid="page-title">{page.title}</h1>
              <PageBody body={page.body} />
            </>
          )}
          {missing && (
            <div data-testid="page-missing">
              <h1 className="text-4xl font-extrabold tracking-tight mb-4">Page not found</h1>
              <p className="mb-6">That page does not exist or is not published.</p>
              <Link to="/" className="font-semibold underline text-[#c2410c]">Back to home</Link>
            </div>
          )}
        </article>
      </main>
      <TransferSiteFooter dark={dark} />
    </div>
  );
};

export default TransferContentPage;
